import React from 'react';

const P = process.env.PUBLIC_URL || '';

const BG_DECO_CLUSTER = `${P}/bg-deco-shipment-cluster.png`;
const BG_DECO_BICYCLE = `${P}/bg-deco-bicycle.png`;
const BG_DECO_SOFA = `${P}/bg-deco-sofa.png`;
const BG_DECO_LAMP_PLANT = `${P}/bg-deco-lamp-plant.png`;

/**
 * Четыре декоративные иллюстрации (доставка / быт) для bg_econt и bg_vinted.
 */
function BgMarketplaceDecoRow({ wrapClass, imgClass }) {
  return (
    <div className={wrapClass} aria-hidden>
      <img src={BG_DECO_CLUSTER} alt="" className={imgClass} width={218} height={186} />
      <img src={BG_DECO_BICYCLE} alt="" className={imgClass} width={218} height={180} />
      <img src={BG_DECO_SOFA} alt="" className={imgClass} width={218} height={180} />
      <img src={BG_DECO_LAMP_PLANT} alt="" className={imgClass} width={218} height={180} />
    </div>
  );
}

export default BgMarketplaceDecoRow;
